export default {
  name: "SecureCheckoutIcon",
  props: {
    data: Object
  },
  computed: {
    primary() {
      var _this$data$primaryCol, _this$data;
      return (_this$data$primaryCol = (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.primaryColor) !== null && _this$data$primaryCol !== void 0 ? _this$data$primaryCol : '#407BFB';
    }
  }
};